// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"159":"98f88bb309ab150405dbe39f3f4abd4ff9d2e3ef","194":"component---src-pages-resume-tsx","245":"component---src-pages-index-tsx","453":"component---src-pages-404-tsx"}[chunkId] + "-" + {"159":"2bced42811d926c3d284","194":"8a0d1f5bafad0169a13a","245":"0d69b5b56a2f88a3721c","453":"3cac974e9cd87d2f6ce7"}[chunkId] + ".js";
};